<template>
    <div class="content-wrapper">
        <div class="row">
            <div class="col-sm-12 col-md-6">
                <app-breadcrumb :page-title="$t('odds')" :directory="$t('datatables')" :icon="'grid'"/>
            </div>
            <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                   
                </div>
            </div>
        </div>

        <app-table
            :id="tableId"
            :options="options"
        />
        
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";

export default {
    extends: CoreLibrary,
    name: "DatatableWithFilter",
    props: ['game_id', 'custom_filters'],
    data() {
        return {
            isAddEditModalActive: false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            selectedUrl: '',
            tableId: 'odds-table',
            rowData: {},
            lineOptions: [],
            marketOptions: [],
            subMarketOptions: [],
            options: {
                name: 'OddsTable',
                showHeader: true,
                //enableHighlights: true,
                // enableRowSelect: true,
                enableSaveFilter: true,
                columns: [
                    {
                        title: '#',
                        type: 'text',
                        key: 'id',
                    },
                    {
                        title: this.$t('type'),
                        type: 'custom-html',
                        key: 'type',
                        modifier: (value, row) => {
                            if (row.live === true){
                                return '<div style="color: #81bf5c;">' + value + '</div>';
                            }
                            return value;
                        }
                    },
                    {
                        title: this.$t('market'),
                        type: 'custom-html',
                        key: 'market',
                        modifier: (value, row) => {
                            const optionExists = this.marketOptions.find((o) => o.id === value);
                            if (!optionExists){
                                this.marketOptions.push(
                                    {
                                        id: value,
                                        name: this.$t(value),
                                    }
                                );
                            }
                            return this.$t(value);
                        }
                    },
                    {
                        title: this.$t('line'),
                        type: 'custom-html',
                        key: 'line',
                        className: 'game-odds-column-highlight',
                        modifier: (data, row) => {
                            if (data != null) {
                                const optionExists = this.lineOptions.find((o) => o.id === data.value);
                                if (!optionExists) {
                                    let market = row.market;
                                    this.lineOptions.push(
                                        {
                                            id: data.value,
                                            name: data.value,
                                        }
                                    );
                                }
                                if (typeof row.market != 'undefined' && row.market === 'asian' && parseFloat(data.value) > 0) {
                                    return '+' + data.value;
                                }
                                return data.value;
                            }
                            return '';
                        }
                    },
                    {
                        title: this.$t('home_over'),
                        type: 'custom-html',
                        key: 'home',
                        //className: 'text-center',
                        modifier: (data, row) => {
                            if (row.home && row.home.value) {
                                let value = '<span style="display: inline-block; width: 50%; text-align;text-align: end; margin-right: 7.5px;">' + row.home.value + '</span>';
                                if (parseFloat(row.home.change) > 0){
                                    value += '<span style="color: #81bf5c; padding-left: 7.5px;">+' + row.home.change + '</span>';
                                } else  if (parseFloat(row.home.change) < 0){
                                    value += '<span style="color: #bf5c5c; padding-left: 7.5px;">' + row.home.change + '</span>';
                                }
                                return value;
                            } else if (row.over && row.over.value) {
                                let value = '<span style="display: inline-block; width: 50%; text-align;text-align: end; margin-right: 7.5px;">' + row.over.value + '</span>';
                                if (parseFloat(row.over.change) > 0){
                                    value += '<span style="color: #81bf5c; padding-left: 7.5px;">+' + row.over.change + '</span>';
                                } else  if (parseFloat(row.over.change) < 0){
                                    value += '<span style="color: #bf5c5c; padding-left: 7.5px;">' + row.over.change + '</span>';
                                }
                                return value;
                            }
                            return '';
                        }
                    },
                    {
                        title: this.$t('draw'),
                        type: 'custom-html',
                        key: 'draw',
                        //className: 'text-center',
                        modifier: (data, row) => {
                            if (row.draw && row.draw.value) {
                                let value = '<span style="display: inline-block; width: 50%; text-align;text-align: end; margin-right: 7.5px;">' + row.draw.value + '</span>';
                                if (parseFloat(row.draw.change) > 0){
                                    value += '<span style="color: #81bf5c; padding-left: 7.5px;">+' + row.draw.change + '</span>';
                                } else  if (parseFloat(row.draw.change) < 0){
                                    value += '<span style="color: #bf5c5c; padding-left: 7.5px;">' + row.draw.change + '</span>';
                                }
                                return value;
                            }
                            return '';
                        }
                    },
                    {
                        title: this.$t('away_under'),
                        type: 'custom-html',
                        //className: 'text-center',
                        modifier: (data, row) => {
                            if (row.away && row.away.value) {
                                let value = '<span style="display: inline-block; width: 50%; text-align;text-align: end; margin-right: 7.5px;">' + row.away.value + '</span>';
                                if (parseFloat(row.away.change) > 0){
                                    value += '<span style="color: #81bf5c; padding-left: 7.5px;">+' + row.away.change + '</span>';
                                } else  if (parseFloat(row.away.change) < 0){
                                    value += '<span style="color: #bf5c5c; padding-left: 7.5px;">' + row.away.change + '</span>';
                                }
                                return value;
                            } else if (row.under && row.under.value) {
                                let value = '<span style="display: inline-block; width: 50%; text-align;text-align: end; margin-right: 7.5px;">' + row.under.value + '</span>';
                                if (parseFloat(row.under.change) > 0){
                                    value += '<span style="color: #81bf5c; padding-left: 7.5px;">+' + row.under.change + '</span>';
                                } else  if (parseFloat(row.under.change) < 0){
                                    value += '<span style="color: #bf5c5c; padding-left: 7.5px;">' + row.under.change + '</span>';
                                }
                                return value;
                            }
                            return '';
                        }
                    },
                    {
                        title: this.$t('stake'),
                        type: 'custom-html',
                        key: 'max',
                        //className: 'text-center',
                        modifier: (data, row) => {
                            if (data != null) {
                                let value = '<span style="display: inline-block; width: 50%; text-align;text-align: end; margin-right: 7.5px;">' + data.value + '</span>';
                                if (parseFloat(data.change) > 0) {
                                    value += '<span style="color: #81bf5c; padding-left: 7.5px;">+' + data.change + '</span>';
                                } else if (parseFloat(data.change) < 0) {
                                    value += '<span style="color: #bf5c5c; padding-left: 7.5px;">' + data.change + '</span>';
                                }
                                return value;
                            }
                            return '';
                        }
                    },
                    {
                        title: this.$t('time'),
                        type: 'text',
                        key: 'time',
                    },
                    {
                        title: this.$t('date'),
                        type: 'text',
                        key: 'date',
                    },
                ],
                actions: [],
                filters: [
                    {
                        "title": this.$t('date_range'),
                        "type": "range-picker",
                        "key": "date",
                        "option": ["today", "thisMonth", "last7Days", "nextYear"],
                    },
                    {
                        "title": this.$t('order_asc_desc'),
                        "type": "checkbox",
                        "key": "orderBy",
                        "option": [
                            {id: 'asc', value: 'ASC'},
                            {id: 'desc', value: 'DESC'},
                        ],
                    },
                    {
                        "title": this.$t('odds_value'),
                        "type": "editable-range-filter",
                        "key": "odds",
                        "maxTitle": "Max",
                        "minTitle": "Min",
                        "sign": "$",
                        "maxRange": 500,
                        "minRange": 0
                    },
                    {
                        "title": this.$t('change'),
                        "type": "editable-range-filter",
                        "key": "change",
                        "maxTitle": "Max",
                        "minTitle": "Min",
                        "sign": "$",
                        "maxRange": 500,
                        "minRange": 0
                    }
                ],
                showFilter: true,
                showSearch: false,
                showCount: true,
                //showClearFilter: true,
                paginationType: "pagination",
                responsive: true,
                rowLimit: 50,
                showAction: false,
                actionType: "default",
                autoRefresh: true,
                paginationOptions: [25, 50, 100, 200, 500],
                orderBy: 'desc',
            },
        }
    },
    created() {
        this.options.url = actions.LOAD_ODDS_HISTORY_TABLE + '/' + this.game_id;
        let customFilters = [];
        //console.log(this.custom_filters);
        if (this.custom_filters) {
            for (const [key, market] of Object.entries(this.custom_filters)) {
                for (const [key, type] of Object.entries(market)) {
                    for (const [key, item] of Object.entries(type)) {
                        if (typeof item === 'object') {
                            let title = item.title;
                            let id = item.id;
                            customFilters.push(
                                { id: id, name: title }
                            );
                        }
                    }
                }
            }
        }
        //console.log(customFilters);
        this.options.filters.push({
            "title": this.$t('line'),
            "type": "checkbox",
            "key": "line",
            "option": this.lineOptions,
            "listValueField": "name"
        });
        this.options.filters.push({
            "title": this.$t('market'),
            "type": "checkbox",
            "key": "market",
            "option": this.marketOptions,
            "listValueField": "name"
        });
        this.options.filters.push({
            "title": this.$t('main_line'),
            "type": "checkbox",
            "key": "main_line",
            "option": [
                { id: '1', name: this.$t('yes')},
            ],
            "listValueField": "name"
        });
        this.options.filters.push({
            "title": this.$t('custom_filters'),
            "type": "checkbox",
            "key": "custom_filters",
            "option": customFilters,
            "listValueField": "name"
        });
    },
    methods: {
        searchAndSelectFilterOptions() {
            /*this.axiosGet(actions.DATATABLE_SEARCH_SELECT).then(response => {
                let name = this.options.filters.find(element => element.title === this.$t('search_and_select'));

                name.option = response.data.map(name => {
                    return {
                        id: name.name,
                        value: name.name
                    }
                });
            });*/
        }
    },
}
</script>